export default {"src":"/_next/static/media/image6.3d05b974.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};